// extracted by mini-css-extract-plugin
export var wrapper = "technologies-module--wrapper--1XQ3B";
export var containerMain = "technologies-module--containerMain--GTu4K";
export var title = "technologies-module--title--NuYjR";
export var desc = "technologies-module--desc--1lO5L";
export var imageContainer = "technologies-module--imageContainer--aTANo";